import React from "react"
import { Box, Flex, Text, MaxWidth } from "@sqymagma/elements"
import { navigationData } from "../../data/navigationData"
import { Link } from "gatsby"
import { theme } from "../../utils/themeGet"
import IconSystem from "../IconSystem"
import MenuItemCalendar from "./MenuItemCalendar"


export default ({ isSticky, path, navTextColor , navBgColor, toggleCalendarMenu, isChronologyPage}) => {


    return (
    <Box
        as="nav"
        width="100vw"
        position={isSticky ? "absolute" : "relative"}
        bottom={isSticky ? "0" : "inherit"}
        zIndex={isSticky ? "-1" : "inherit"}
        top={!isSticky && "-5px"}
        bg="ui07"
        css={` {
            transition: position ease-out 0.35s, bottom ease-out 0.35s;
        }`}
        boxShadow="0px 3px 4px rgba(0, 0, 0, 0.15)"
        
    >
        <MaxWidth>
        <Flex justifyContent="flex-start" alignItems="center">
            {navigationData && (
                <>
                <Text as="ul" display={["none", null, "flex"]}>
                {navigationData.filter(el => el.mainMenu).map((menuItem, idx) => (
                <Text 
                    key={idx} as="li" textStyle="s" py="10px" px={["xs","xs","xs","s"]} mr={["xs","xs","xs", "s"]} caps
                    color={path.includes(menuItem.link) && !isSticky ? navTextColor : "text05"}
                    bg={path.includes(menuItem.link) && !isSticky ? menuItem.color : "transparent"}
                    css={` {
                        transition: opacity ease 0.3s;
                        &:hover {
                        color: ${path.includes(menuItem.link) && !isSticky
                            ? "text01"
                            : theme(`color.${menuItem.color}`)};
                        }
                    } `}
                >
                    <Link to={menuItem.link}>{menuItem.text}</Link>
                </Text>
                ))}
            </Text>
           
            <Text as="ul" ml={"auto"} display="flex">
                {isChronologyPage && 
                    <MenuItemCalendar toggleCalendarMenu={toggleCalendarMenu}  mr={["xs","xs","xs", "s"]}/>
                }

                {navigationData.filter(el => !el.mainMenu).map((menuItem, idx) => (
        
                   <Text 
                    key={idx} as="li" textStyle="label"
                    py="11px" px={["xs","xs","xs","s"]}
                    display={["none", null, "inline-flex"]} alignItems="center"
                    color={path.includes(menuItem.link) && !isSticky ? navTextColor : "text05"}
                    bg={path.includes(menuItem.link) && !isSticky ? menuItem.color : "transparent"}

                   css={`{
                       transition: all ease-out 0.35s;
                       & :hover a { color: ${theme(`color.brand04`)}} }
                       & :hover * { fill: ${theme(`color.brand04`)}} }
                   }`}
               >
                   <IconSystem name="file" height="17px" mr="8px" fill={path.includes(menuItem.link) && !isSticky ? navTextColor : "text05"}/>
                   <Link to="/manifiesto">
                   nuestro manifiesto
                   </Link>
               </Text>
                ))}
            </Text>
                </>
            )}
        </Flex>
        </MaxWidth>
    </Box>
    )
}
